import { render, staticRenderFns } from "./ListWithPage.vue?vue&type=template&id=30652e78&scoped=true&"
import script from "./ListWithPage.vue?vue&type=script&lang=js&"
export * from "./ListWithPage.vue?vue&type=script&lang=js&"
import style0 from "./ListWithPage.vue?vue&type=style&index=0&id=30652e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30652e78",
  null
  
)

export default component.exports